import React from 'react';
import PropTypes from 'prop-types';
import styled from "@emotion/styled"


const CustomInputFieldWrapper = styled.div``;

const CustomInput = styled.textarea`
    width: ${props => (props.fullWidth) ? "100%" : (!props.width) ? "140px" : `${props.width}px`};
    /* default/shade/white */
    padding: 8px;    
    background: #FFFFFF;
    /* default/gray/300 */
    
    border: 1.2px solid #E2E8F0;
    box-sizing: border-box;
    border-radius: 4px;
    color: ${props => props.disabled ? "#718096;" : "black"};
`;

export const CustomInputLabel = styled.div`
    margin-bottom: 8px;
    font-family: Metropolis,serif;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 16px;
    /* identical to box height, or 100% */
    
    display: flex;
    align-items: center;
    
    /* default/gray/600 */
    color: var(--color-gray-600);
`;

function CustomTextArea({label, name, value, placeholder, disabled, onChange, rows, width, fullWidth}) {
    return (
        <CustomInputFieldWrapper>
            {
                label &&
                <CustomInputLabel>
                    {label}
                </CustomInputLabel>
            }

            <CustomInput
                name={name}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                disabled={disabled}
                width={width}
                rows={rows}
                fullWidth={fullWidth}
            />

        </CustomInputFieldWrapper>
    );
}

CustomTextArea.propTypes = {
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
};
CustomTextArea.defaultProps = {};

export default CustomTextArea;
